import styled from 'styled-components';

import { ToolTip } from 'src/app/components/Elements/ToolTip';
import { Typography } from 'src/app/components/Elements/Typography';

const dividerMargin = '40px';

export const Image = styled.img`
  display: block;
  width: auto;
  height: 8.4rem;
  margin-bottom: ${props => props.theme.space.s4};
`;

export const NoMedicationsInfo = styled(ToolTip)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${dividerMargin} 0;
  z-index: 0;
`;

export const HeaderText = styled.h3`
  font-family: ${props => props.theme.fonts.circular} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;

  font-size: ${props => props.theme.fontSizes.headerFour} !important;

  ${props => props.theme.mediaQueries.small} {
    font-size: ${props => props.theme.fontSizes.headerThree} !important;
  }

  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  text-align: center;
  margin-top: ${dividerMargin};
  padding: 0 0 ${props => props.theme.space.s3} !important;
`;

export const DoctorCardSection = styled.div`
  display: flex;
  justify-content: space-between;
  height: 18rem;
  margin-top: ${props => props.theme.space.s7} !important;

  ${props => props.theme.mediaQueries.extraLargeDown} {
    flex-direction: column;
    height: 28rem;
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    flex-direction: row;
    height: 18rem;
  }

  ${props => props.theme.mediaQueries.smallDown} {
    flex-direction: column;
    height: 28rem;
  }
`;

export const DoctorText = styled.div`
  display: flex;
  align-items: center;
  width: 32.2%;

  ${props => props.theme.mediaQueries.extraLargeDown} {
    width: 100%;
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    width: 18rem;
  }

  ${props => props.theme.mediaQueries.smallDown} {
    width: 100%;
  }
`;

export const DoctorVisitsText = styled(Typography)`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.space.s1} !important;
`;
